import { createFileRoute } from "@tanstack/react-router";

import { Help } from "@/features/my/help";

export const Route = createFileRoute("/(member)/(protected)/my/help")({
  component: Help,
});
